import { render, staticRenderFns } from "./PolicyWhatsappBusiness.vue?vue&type=template&id=ced2e63a&scoped=true"
import script from "./PolicyWhatsappBusiness.vue?vue&type=script&lang=js"
export * from "./PolicyWhatsappBusiness.vue?vue&type=script&lang=js"
import style0 from "./PolicyWhatsappBusiness.vue?vue&type=style&index=0&id=ced2e63a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ced2e63a",
  null
  
)

export default component.exports